
export const rule_IN = (value1: any, value2: any): boolean =>
{
    if (!Array.isArray(value1) || !Array.isArray(value2)) {
        return includesNotArray(value1, value2);
    }

    if (value1.length === 0 && value2.length === 0) {
        return true;
    }

    if (value1.length === 0 || value2.length === 0) {
        return false;
    }

    // let contains = value2.intersect(value1).length > 0;
    let contains = value1.some(element => value2.includes(element));
    return contains;
}

export const includesNotArray = (value1: any, value2: any): boolean => {
    if (!Array.isArray(value1) && Array.isArray(value2)) {
        return value2.includes(value1);
    }
    if (Array.isArray(value1) && !Array.isArray(value2)) {
        return value1.includes(value2);
    }

    return value2.includes(value1);
}
